import styled from "styled-components";

export const MainLayout = styled.div`
  padding: 4rem 4rem;
  @media screen and (max-width: 768px) {
    padding: 3rem 2rem;
  }
  @media screen and (max-width: 480px) {
    padding: 2rem 1.25rem;
  }
`;

export const InnerLayout = styled.div`
  padding: 3rem 0;
`;
